import { render } from "./NoteTrash.vue?vue&type=template&id=70b172cf&scoped=true"
import script from "./NoteTrash.vue?vue&type=script&lang=js"
export * from "./NoteTrash.vue?vue&type=script&lang=js"

import "./NoteTrash.vue?vue&type=style&index=0&id=70b172cf&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b172cf"]])

export default __exports__